import { useTranslation } from 'react-i18next';

import { IconButton } from '@hotjar/hotsauce';

interface ResponseCardAddCommentProps {
  onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

export function ResponseCardAddComment({ onClick }: ResponseCardAddCommentProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <IconButton
      tooltipText={t('comment:create.confirm')}
      description={t('comment:create.label')}
      kind="ghost"
      onClick={onClick}
      required-access="write"
      size="s"
      icon="comment"
    />
  );
}
